import React from 'react';
import { MdLockOutline } from "react-icons/md";
import cardImage from '../assets/credit_card_closeup.png';

const FinancialProducts: React.FC = () => {
  return (
    <section className="w-full max-w-7xl mx-auto px-6 lg:px-12 py-20">
      <div className="mb-14">
        <h2 className="text-2xl md:text-3xl md:text-5xl font-serif font-semibold leading-tight max-w-4xl text-black">
          Financial products designed with empathy and speed.
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 h-auto md:h-[600px]">
        {/* Block 1: Speed Guarantee (Large Top Left) */}
        <div className="md:col-span-8 bg-white rounded-[8px] p-8 md:p-12 border border-gray-100 shadow-sm relative overflow-hidden group">
          <div className="relative  space-y-4">
            <span className="text-[var(--primary)] text-[10px] md:text-xs font-black uppercase tracking-[0.2em] block mb-2">
              Speed Guarantee
            </span>
            <h3 className="text-3xl font-serif text-black leading-tight max-w-lg  ">
              10-minute approval even with low CIBIL
            </h3>
            <p className="text-[var(--text-gray)] font-semibold text-lg max-w-lg leading-relaxed pt-2">
              Our proprietary algorithm looks beyond just scores to understand your true repayment potential.
            </p>
          </div>
          {/* Custom SVG Bolt Watermark */}
          <div className="absolute -bottom-0 -right-10 opacity-[0.03] group-hover:opacity-[0.05] transition-opacity duration-1000 rotate-[-5deg]">
            <svg width="300" height="200" viewBox="0 0 134 167" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M33.3333 166.667L41.6667 108.333H0L75 0H91.6667L83.3333 66.6667H133.333L50 166.667H33.3333Z" fill="#191C1E" />
            </svg>
          </div>
        </div>

        {/* Block 2: Zero Hidden Charges (Small Top Right) */}
        <div className="md:col-span-4 bg-[var(--primary)] rounded-[8px] p-8 md:p-10 flex flex-col justify-between text-white group relative overflow-hidden">
          <div className="relative ">
            <div className="w-12 h-12 md:w-14 md:h-14  flex items-center justify-center  transition-transform group-hover:rotate-12">
              <MdLockOutline className="text-xl md:text-2xl" />
            </div>
            <h3 className="text-2xl  font-serif font-semibold ">Zero Hidden Charges</h3>
            <p className="text-white/80 font-thin text-sm md:text-base leading-relaxed">
              Every paisa accounted for. What you see is what you pay. Transparent fee structure.
            </p>
          </div>
          <div className="relative  mt-2">
            <a href="#" className="inline-flex items-center gap-2 text-xs md:text-sm font-semibold uppercase tracking-widest ">
              View Charges <span className="transform group-hover:translate-x-1 duration-300">→</span>
            </a>
          </div>
        </div>

        {/* Block 3: Paperless KYC (Small Bottom Left) */}
        <div className="md:col-span-4 bg-[#F7FAFC] rounded-[8px] p-8 flex flex-col justify-between border border-gray-100 shadow-sm group">
          <div className="w-12 h-12 md:w-14 md:h-14  flex items-center justify-center mb-2 group-hover:scale-110 transition-transform">
            <svg width="27" height="30" viewBox="0 0 27 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.5 30C3.25 30 2.1875 29.5625 1.3125 28.6875C0.4375 27.8125 0 26.75 0 25.5V21H4.5V0L6.75 2.25L9 0L11.25 2.25L13.5 0L15.75 2.25L18 0L20.25 2.25L22.5 0L24.75 2.25L27 0V25.5C27 26.75 26.5625 27.8125 25.6875 28.6875C24.8125 29.5625 23.75 30 22.5 30H4.5ZM22.5 27C22.925 27 23.2812 26.8563 23.5688 26.5688C23.8563 26.2812 24 25.925 24 25.5V4.5H7.5V21H21V25.5C21 25.925 21.1437 26.2812 21.4312 26.5688C21.7188 26.8563 22.075 27 22.5 27ZM9 10.5V7.5H18V10.5H9ZM9 15V12H18V15H9ZM21 10.5C20.575 10.5 20.2188 10.3563 19.9312 10.0688C19.6437 9.78125 19.5 9.425 19.5 9C19.5 8.575 19.6437 8.21875 19.9312 7.93125C20.2188 7.64375 20.575 7.5 21 7.5C21.425 7.5 21.7812 7.64375 22.0688 7.93125C22.3563 8.21875 22.5 8.575 22.5 9C22.5 9.425 22.3563 9.78125 22.0688 10.0688C21.7812 10.3563 21.425 10.5 21 10.5ZM21 15C20.575 15 20.2188 14.8563 19.9312 14.5688C19.6437 14.2812 19.5 13.925 19.5 13.5C19.5 13.075 19.6437 12.7188 19.9312 12.4312C20.2188 12.1437 20.575 12 21 12C21.425 12 21.7812 12.1437 22.0688 12.4312C22.3563 12.7188 22.5 13.075 22.5 13.5C22.5 13.925 22.3563 14.2812 22.0688 14.5688C21.7812 14.8563 21.425 15 21 15ZM4.5 27H18V24H3V25.5C3 25.925 3.14375 26.2812 3.43125 26.5688C3.71875 26.8563 4.075 27 4.5 27ZM3 27C3 27 3 26.8563 3 26.5688C3 26.2812 3 25.925 3 25.5V24V27Z" fill="#048BE1" />
            </svg>
          </div>
          <div>
            <h3 className="text-2xl font-serif font-semibold text-[var(--text-primary)] mb-4">Paperless KYC</h3>
            <p className="text-[var(--text-gray)] font-medium text-sm md:text-base leading-relaxed">
              Upload from your phone and get verified in under 120 seconds. No physical visits required.
            </p>
          </div>
        </div>

        {/* Block 4: Flexible Repayments (Large Bottom Right) */}
        <div className="md:col-span-8 bg-[#E2E8F0] rounded-[8px] p-8 relative overflow-hidden flex flex-col md:flex-row items-center gap-10 group">
          <div className="flex-1 space-y-4 relative">
            <h3 className="text-2xl font-serif font-semibold text-[var(--text-primary)] leading-tight">
              Flexible Repayments
            </h3>
            <p className="text-[var(--text-gray)] font-medium text-base md:text-lg leading-relaxed">
              Choose tenures that match your cashflow. Pre-pay anytime with zero penalties.
            </p>
            <div className="pt-2 relative">
              <div className="h-2 w-full max-w-[300px] bg-white rounded-full relative overflow-hidden shadow-inner">
                <div className="absolute top-0 left-0 h-full w-[60%] bg-[var(--primary)] rounded-full group-hover:w-[75%] transition-all duration-1000" />
              </div>
              <div className="flex justify-between max-w-[300px] mt-2">
                <span className="text-[9px] font-black text-gray-500 uppercase tracking-widest">Short Term</span>
                <span className="text-[9px] font-black text-gray-500 uppercase tracking-widest">Mid Term</span>
              </div>
            </div>
          </div>
          <div className="flex-1 relative w-full md:w-auto flex justify-center md:justify-end">
            <div className="relative p-2 bg-white rounded-[24px] shadow-2xl transform rotate-1 group-hover:rotate-0 transition-transform duration-700 w-full max-w-[440px]">
              <img src={cardImage} alt={`${import.meta.env.VITE_COMPANY_NAME} loan card details`} className="rounded-[18px] w-full aspect-video object-cover" />
            </div>
          </div>
          {/* Subtle Shape */}
          <div className="absolute bottom-[-10%] right-[-10%] w-64 h-64 bg-white opacity-20 rounded-full blur-3xl" />
        </div>
      </div>
    </section>
  );
};

export default FinancialProducts;
